import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

type Props = {
    offset?: number;
    forceShow?: boolean;
    onEnter?: () => any;
    fallback?: any;
    children: any;
};

export const LazyContainer = ({ offset = 0, onEnter, forceShow = false, fallback = null, children }: Props) => {
    const [ref, setRef] = useState(null);
    const [intersected, setIntersected] = useState(false);
    useEffect(
        () => {
            if (!ref) {
                return;
            }
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !intersected) {
                            setIntersected(true);
                            if (onEnter) {
                                onEnter();
                            }
                        }
                    });
                },
                {
                    rootMargin: `0px 0px ${offset}px 0px`,
                    threshold: [0, 0.1, 0.2, 0.3, 0.5, 0.7, 1],
                }
            );
            observer.observe(ref);
            return () => observer.disconnect();
        },
        [ref, intersected]
    );
    return <div ref={setRef}>{intersected || forceShow ? children : fallback}</div>;
};
